define('gigaset_recurring/classes/provider/billwerk/steps/_abstract',[
	"jquery",
	"lodash",
	"lucid"
], function(
	$,
	_,
	lucidJS
) {

	function AbstractStep() {
		lucidJS.EventEmitter.call(this);
		this._data = {};
		this._formData = {};
	}

	AbstractStep.prototype = _.create(new lucidJS.EventEmitter, {
		constructor: AbstractStep,

		previousStep: null,
		nextStep: null,

		_formData: null,
		_data: null,
		_id: null,
		_active: false,
		_complete: false,
		_shouldDisplaySidebar: true,
		_displayInSidebar: true,
		progressContent: null,

		/**
		 * Initialize the step
		 */
		initialize: function() {

		},

		/**
		 * Set the ID of this step
		 * @param id
		 */
		setId: function(id) {
			this._id = id;
		},

		/**
		 * Retrieve the ID of this step
		 * @returns {*}
		 */
		getId: function() {
			return this._id;
		},

		/**
		 * Set arbitrary data to the step which will be transported from step to step
		 * in order to complete the checkout.
		 * Overwrites the whole form-data content
		 * @param formData
		 * @returns {AbstractStep}
		 */
		setFormData: function(formData) {
			this._formData = formData;
			return this;
		},

		/**
		 * Retrieve arbitrary data to the step which will be transported from step to step
		 * in order to complete the checkout
		 * @returns {null}
		 */
		getFormData: function(key) {
			if ("undefined" !== typeof key) {
				return _.get(this._formData, key);
			}

			return this._formData;
		},

		/**
		 * Add arbitrary data to the step which will be transported from step to step in
		 * order to complete the checkout
		 * @param formData
		 * @returns {AbstractStep}
		 */
		addFormData: function(formData) {
			_.merge(this._formData, formData);
			return this;
		},

		/**
		 * Collect data from the step and save it via this.addData
		 * @returns {AbstractStep}
		 */
		saveFormData: function() {
			this.addFormData(this.collectFormData());
			return this;
		},

		/**
		 * Collect data from the step and save it via this.addData
		 * @returns {Promise}
		 */
		saveFormDataServerSide: function() {
			var formData = this.collectFormData();
			this.addFormData(formData);

			return this._saveFormDataServerSide(formData);
		},

		_saveFormDataServerSide: function(formData) {
			var tick = _.bind(function(response) {
				response = _.get(response, 'responseJSON', response);

				var deferred = $.Deferred();
				var blocks = _.get(response, 'blocks');
				var quote = _.get(response, 'quote');
				var error = _.get(response, 'error');

				if (!_.isEmpty(blocks)) {
					this.progressContent = _.get(blocks, 'progress');
					this.emit("updateBlocks", blocks);
				}

				if (!_.isEmpty(quote)) {
					this.emit("updateQuote", quote);
				}

				if (error) {
					var message = _.get(response, "message");
					var displayMessage = message;
					if (_.isArray(displayMessage)) {
						displayMessage = [
							'<ul>',
							_.map(message, function(m) { return ['<li>', m, '</li>'].join(" "); }).join(" "),
							'</ul>'
						].join(" ");
					}

					var url = _.get(response, "url");
					if (url) {
						this.getData("module").once("modal.close", function() {
							window.location.href = url;
						});
					}

					var e = new Error(message);

					var qaddressInformation = _.get(response, "qaddress");
					if (qaddressInformation) {
						e.qaddress = qaddressInformation;
						e.errorCode = ['QAddressValidationError'];
					}

					this.emit("error", e, displayMessage);
					deferred.reject(response);
				} else {
					deferred.resolve(response);
				}

				return deferred.promise();
			}, this);

			return $.ajax({
				url: this.getData("saveDataUrl"),
				method: 'post',
				data: formData
			}).then(tick, tick); // always() is not possible here as we're modifying the returned promise
		},

		/**
		 * Collect data from the steps form (if any)
		 * @returns {{}}
		 */
		collectFormData: function() {
			return {};
		},

		/**
		 * Set arbitrary data to the step which might be needed in controller logic
		 * Overwrites the whole data content
		 * @param data
		 * @returns {AbstractStep}
		 */
		setData: function(data) {
			this._data = data;
			return this;
		},

		/**
		 * Retrieve arbitrary data from the step which might be needed in controller logic
		 * @param key
		 * @returns {*}
		 */
		getData: function(key) {
			if ("undefined" === typeof key) {
				return this._data;
			}
			return _.get(this._data, key);
		},

		/**
		 * Add arbitrary data to the step which might be needed in controller logic
		 * @param data
		 * @returns {AbstractStep}
		 */
		addData: function(data) {
			_.assign(this._data, data);
			return this;
		},

		/**
		 * Overwrite this in a concrete class to implement validation logic
		 * @returns {boolean}
		 */
		validate: function() {
			return true;
		},

		/**
		 * Submit this step, effectively opening the next step
		 * @returns {boolean}
		 */
		submit: function() {
			var valid = this.validate();

			var proceed = _.bind(function() {
				this.emit("submit");
				var result = this.saveFormData();
				var next = _.bind(function() {
					this.next();
				}, this);

				if (result !== this && _.isFunction(_.get(result, "done"))) {
					result.done(next);
				} else {
					next();
				}
			}, this);

			if (_.isFunction(_.get(valid, "done"))) {
				valid.done(proceed);
			} else {
				if (valid) {
					proceed();
				}
			}
		},

		/**
		 * Set this step to be active/inactive
		 * Appropriate events will be fired
		 * @param flag
		 * @return {AbstractStep}
		 */
		setActive: function(flag, data) {
			flag = "undefined" === typeof flag ? true : !!flag;
			this._active = flag;
			this.emit(flag ? "active" : "inactive", data);

			if (flag) {
				this.setComplete(false);

				if (this.previousStep) {
					this.previousStep.setActive(false, data);
					this.previousStep.setComplete(true, data);
				}

				if (this.nextStep) {
					var step = this;
					while (step.nextStep) {
						step = step.nextStep.setActive(false, data);
					}
				}
			}

			return this;
		},

		/**
		 * Set this step to be complete/incomplete
		 * Appropriate events will be fired
		 * @param flag
		 * @return {AbstractStep}
		 */
		setComplete: function(flag, data) {
			flag = "undefined" === typeof flag ? true : !!flag;
			this._complete = flag;
			this.emit(flag ? "complete" : "incomplete", data);
			if (!flag && this.nextStep) {
				this.nextStep.setComplete(false, data);
			}
			return this;
		},

		/**
		 * @returns {boolean}
		 */
		isComplete: function() {
			return this._complete;
		},

		/**
		 * Open this step
		 * @returns {AbstractStep}
		 */
		open: function(data) {
			this.emit("open", data);
			this.setActive(true, data);
			return this;
		},

		/**
		 * Open the next step
		 * @returns {*|AbstractStep}
		 */
		next: function(data) {
			this.emit("next", data);
			this.emit("close", data);
			if (this.nextStep) {
				return this.nextStep
					.addFormData(this.getFormData())
					.open(data);
			}
		},

		/**
		 * Open the previous step
		 * @returns {*|AbstractStep}
		 */
		previous: function(data) {
			this.emit("previous", data);
			this.emit("close", data);
			if (this.previousStep) {
				return this.previousStep
					.open(data);
			}
		},

		displayInSidebar: function() {
			return this._displayInSidebar;
		},

		getTitle: function() {
			return this.getData("title");
		},

		getProgressContent: function() {
			if (this.progressContent !== null) {
				return this.progressContent;
			}

			return '';
		},

		shouldDisplaySidebar: function() {
			return this._shouldDisplaySidebar;
		}
	});

	return AbstractStep;

});
